import React from "react";
import { Box } from "@mui/material";

type Props = {
  src?: string;
};
export const ImgRectangular = (props: Props) => {
  const { src } = props;

  return (
    <>
      <Box>
        <Box component="img" src={src} alt="" width={200} />
      </Box>
    </>
  );
};
